module.exports = __webpack_public_path__ + "media/images/loghi/predictor_correct-a44073b79079f0a9779a1c4ef6504a2f.svg";